import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Header from "../components/Header/Header.js";
import { fetchAPI } from "../api";

export default function Home() {
  const navigate = useNavigate();
  const [ongoingMatchId, setOngoingMatchId] = useState(null);
  
  // Force l'affichage du bouton "Nouveau match" temporairement
  const forceNewMatch = false;

  useEffect(() => {
    // Changer le titre de la page
    document.title = 'ESMANAGER';
    
    // Vérifie s'il y a un match en cours dans le localStorage ET en base de données
    const checkOngoingMatch = async () => {
      try {
        const keys = Object.keys(localStorage).filter(k => k.startsWith('match-state-'));
        let foundMatch = null;
        
        for (const key of keys) {
          const raw = localStorage.getItem(key);
          if (!raw) continue;
          const state = JSON.parse(raw);
          if (state && state.isMatchEnded === false) {
            const id = key.replace('match-state-', '');
            
            // Vérifier en base de données si le match est vraiment en cours
            try {
              const matchData = await fetchAPI(`/api/matches/${id}`);
              if (matchData && matchData.status === 'en_cours') {
                foundMatch = id;
                break;
              } else {
                // Le match est terminé en base, nettoyer le localStorage
                localStorage.removeItem(key);
                console.log(`localStorage nettoyé pour le match ${id} terminé`);
              }
            } catch (e) {
              // Si erreur API (404 par exemple), nettoyer le localStorage
              console.log(`Erreur API pour le match ${id}, nettoyage du localStorage`);
              localStorage.removeItem(key);
            }
          }
        }
        setOngoingMatchId(foundMatch);
      } catch (e) {
        setOngoingMatchId(null);
      }
    };
    
    checkOngoingMatch();
    
    // Re-vérifier périodiquement et quand la fenêtre devient active
    const interval = setInterval(checkOngoingMatch, 2000); // Vérification toutes les 2 secondes
    const handleFocus = () => checkOngoingMatch(); // Vérifier quand on revient sur l'onglet
    const handleStorageChange = () => checkOngoingMatch(); // Vérifier quand le localStorage change
    
    window.addEventListener('focus', handleFocus);
    window.addEventListener('storage', handleStorageChange);
    
    return () => {
      clearInterval(interval);
      window.removeEventListener('focus', handleFocus);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  return (
    <div>
      <div>
        <Header />
      </div>
      <div style={{ padding: "2rem", textAlign: "center" }}>
        <h1>ESMANAGER</h1>

        <div className="button-container">
          <button onClick={() => navigate("/joueurs")} className="button">Statistiques joueur</button>
          <button onClick={() => navigate("/equipe")} className="button">Statistiques équipe</button>
          <button onClick={() => navigate("/matchs")} className="button">Liste des matchs</button>
          <button onClick={() => navigate("/live")} className="button">Voir le match en direct</button>
          <button onClick={() => navigate("/gestion-joueurs")} className="button">Gérer les joueurs</button>
          {ongoingMatchId && !forceNewMatch ? (
            <button onClick={() => navigate("/match", { state: { matchId: Number(ongoingMatchId) } })} className="button-secondary">
              Reprendre le match
            </button>
          ) : (
            <button onClick={() => navigate("/creatematch")} className="button-secondary">Nouveau match</button>
          )}
        </div>
      </div>
    </div>
  );
}

